var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mx-auto mt-5 mb-5"},[_c('div',{staticClass:"flex flex-col items-center justify-center text-center"},[_vm._v(" 😞 "),_c('h1',{staticClass:"text-3xl font-bold text-white"},[_vm._v("No Promotions Available")]),_c('p',{staticClass:"text-white"},[_vm._v("Check back later for exciting offers!")])])])
}]

export { render, staticRenderFns }